module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud2.bae7023bd9f70a8b5c6bd95b32d611a4.png";